import React, { useEffect, useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import styles from './Game.module.less';
import Menu from './components/Menu';
import Loading from './components/Loading';
import BackToTop from './components/BackToTop';
import Router from './components/Router';
import { CONTEXT, GAME_TABS } from '../../config';
import { createAxios } from '../../utils/utils';
import { scrollClear } from '../../actions/game';
import useLog from './hooks/useLog';

export default () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path, url } = useRouteMatch();
  const [report] = useLog();

  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    createAxios().then(axios => {
      axios
        .get(GAME_TABS, {
          params: {
            pageType: 'newGame',
          },
        })
        .then(res => {
          if (res.data.status !== 0 || !res.data.data || res.data.data.length <= 0)
            throw new Error('no tabs.');

          setTabs(res.data.data.sort((a, b) => a.order - b.order));
        })
        .catch(() => {
          history.replace(`${CONTEXT}/game999999?sourcePage=Game`);
        });
    });
  }, []);

  useEffect(() => {
    if (history.action !== 'POP') {
      dispatch(scrollClear());
    }
  }, []);

  useEffect(() => {
    let _StartTime = Date.now();
    return () => {
      report('I', 'View_Time', {
        source: 'Game',
        time: Math.ceil((Date.now() - _StartTime) / 1000),
      });
    };
  }, []);

  return (
    <div className={styles.Game}>
      {tabs.length > 0 && <Menu base={url} tabs={tabs} />}
      {tabs.length > 0 && <Router path={path} base={url} tabs={tabs} />}
      {tabs.length <= 0 && <Loading offset={50} />}
      <BackToTop />
    </div>
  );
};
